export const genericToastErrorMessage = 'Что-то пошло не так'
